import React, { useState, useEffect } from 'react';
import { clientAPI } from '../../../services/api';
import { formatDisplayDate } from '../../../utils/dateFormat';
import './ScAssignmentHistorySection.css';

const PROGRAM_LABELS = {
  primary:    'Primary SC',
  coverage:   'Coverage',
  closeout:   'Closeout',
  hug:        'HUG',
};

function ScAssignmentHistorySection({ clientId }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!clientId) return;
    clientAPI.getAssignmentHistory(clientId)
      .then((res) => setHistory(res.data?.data || []))
      .catch(() => setHistory([]))
      .finally(() => setLoading(false));
  }, [clientId]);

  if (loading) return null;
  if (history.length === 0) return null;

  const formatName = (row) =>
    [row.staff_last_name, row.staff_first_name].filter(Boolean).join(', ') || '—';

  const formatAssignedBy = (row) => {
    if (!row.assigned_by) return null;
    return [row.assigned_by_last_name, row.assigned_by_first_name].filter(Boolean).join(', ') || null;
  };

  const formatDate = (d) => (d ? formatDisplayDate(d) : null);

  return (
    <div className="form-section sc-history-section">
      <div className="section-title-row">
        <h3 className="section-title">SC Assignment History</h3>
        <button
          type="button"
          className="sc-history-toggle"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Hide' : `Show (${history.length})`}
        </button>
      </div>

      {expanded && (
        <table className="sc-history-table">
          <thead>
            <tr>
              <th>Role</th>
              <th>Service Coordinator</th>
              <th>Assigned</th>
              <th>Unassigned</th>
              <th>Assigned by</th>
            </tr>
          </thead>
          <tbody>
            {history.map((row) => (
              <tr key={row.id} className={!row.unassigned_at ? 'sc-history-active' : ''}>
                <td>{PROGRAM_LABELS[row.program] || row.program}</td>
                <td>{formatName(row)}</td>
                <td>{formatDate(row.assigned_at) || '—'}</td>
                <td>{row.unassigned_at ? formatDate(row.unassigned_at) : <span className="sc-history-current">Current</span>}</td>
                <td>{formatAssignedBy(row) || <span className="sc-history-unknown">—</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ScAssignmentHistorySection;
